import MainModal from '@/common/components/base/modal/Modal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import React from 'react';
import UserInputMismatchIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/images/UserInputMismatch.svg?react';
import ErrorInquiryIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/images/ErrorInquiryIcon.svg?react';
import { Box } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography';
import Button from '@/common/components/base/button/Button';

type params = {
  open: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  status: number;
  onRepeat?: () => void;
};
const UserInputMismatch: React.FC<params> = ({
  open,
  setOpenModal,
  status,
  onRepeat,
}) => {
  return (
    <MainModal open={open} closeModal={() => setOpenModal(false)}>
      {status < 500 ? (
        <TitleDescription>عدم تطابق کد ملی و تاریخ تولد</TitleDescription>
      ) : (
        <TitleDescription>خطا در دریافت اطلاعات</TitleDescription>
      )}
      <Box
        w="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        mt={32}
        flexDirection="column"
        gap={16}
      >
        {status < 500 ? (
          <>
            <UserInputMismatchIcon />
            <Typography>
              کد ملی و تاریخ تولد وارد شده مطابقت ندارند. لطفاً اطلاعات را بررسی
              کرده و مجدد تلاش کنید!
            </Typography>
          </>
        ) : (
          <>
            <ErrorInquiryIcon />
            <Typography>
              متاسفانه مشکلی پیش آمده، لطفا مجدد تلاش کنید!
            </Typography>
          </>
        )}
      </Box>
      <Box
        display="flex"
        alignItems="start"
        justifyContent="space-between"
        gap={8}
        mt={32}
      >
        <Button
          variant="outlined"
          color="common"
          w={'50%'}
          onClick={() => setOpenModal(false)}
        >
          بازگشت
        </Button>
        <Button
          w={'50%'}
          onClick={() => {
            setOpenModal(false);
            onRepeat?.();
          }}
        >
          درخواست مجدد
        </Button>
      </Box>
    </MainModal>
  );
};

export default UserInputMismatch;
